<template>
    <vx-box-glass class="relative">
        <vx-wallpaper :icon="faSparkles"></vx-wallpaper>
        <div class="inset-s-0 inset-bs-0 h-full w-full absolute bg-white/50"></div>

        <div class="relative flex items-start gap-4 p-5">
            <div class="flex-1 min-w-0">
                <p class="text-center font-semibold text-slate-700 mb-1">Daily Brief</p>
                <p class="text-sm text-slate-600">
                    You have
                    <template v-for="(item, index) in briefItems" :key="item.sectionValue">
                        <meta-badge
                            shadow
                            :color="item.color"
                            class="ml-1 cursor-pointer transition hover:scale-105 active:scale-90"
                            @click="focusSection(item.sectionValue)"
                            >{{ item.count }} {{ item.text }}</meta-badge
                        ><template v-if="index < briefItems.length - 2">, </template
                        ><template v-else-if="index === briefItems.length - 2">{{
                            briefItems.length > 2 ? ', and ' : ' and '
                        }}</template> </template
                    >.
                </p>
            </div>
        </div>
    </vx-box-glass>
</template>

<script lang="ts" setup>
import { faSparkles } from '@fortawesome/pro-solid-svg-icons';
import { VxBoxGlass, VxWallpaper } from '@voxie/frontend-components';
import { computed } from 'vue';
import MetaBadge from '~/components/general/MetaBadge.vue';
import type { MetaBadgeColor } from '~/components/general/MetaBadge.types';
import { ACTIVE_THREAD_SECTIONS, THREAD_SECTIONS, type ThreadSectionValue } from '~/constants/messageHub';
import { useIntelligentInbox } from '../useIntelligentInbox';
import Bus from '~/globals/eventBus';

type BriefItem = {
    text: string;
    count: number;
    sectionValue: ThreadSectionValue;
    color: MetaBadgeColor;
};

const { sectionCounts } = useIntelligentInbox();

const getSectionColor = (sectionValue: ThreadSectionValue): MetaBadgeColor => {
    return THREAD_SECTIONS[sectionValue].color;
};

const briefItems = computed<BriefItem[]>(() =>
    Object.values(THREAD_SECTIONS)
        .filter((section) => ACTIVE_THREAD_SECTIONS.includes(section.value))
        .map((section) => ({
            text: section.label,
            count: sectionCounts.value[section.value] ?? 0,
            sectionValue: section.value,
            color: getSectionColor(section.value),
        }))
);

const focusSection = (sectionValue: ThreadSectionValue): void => {
    Bus.$emit('intelligentInbox:focusSection', sectionValue);
};
</script>
